import { createContext } from 'react';

/**
 * The outlet a counter's figures belong to, where the device sells for more than
 * one — `undefined` where it sells for one, which has nothing to tell apart.
 *
 * Issue #254: several outlets' cash goes into one drawer, and Day Close agrees
 * each outlet's on its own. So a screen that counts takings says whose it is
 * counting. `TillFrame` provides it, rather than `SellGoods` passing it down:
 * that screen sits between the frame and the count and has no other reason to
 * know.
 */
export const SharedDrawer = createContext<string | undefined>(undefined);
